(() => {
  if (customElements.get('xp-new-arrivals')) return;
  customElements.define('xp-new-arrivals', class extends HTMLElement {
    async connectedCallback() {
      const grid=this.querySelector('.xp-arrivals__grid');
      try {
        const url=new URL(this.dataset.url,location.origin);
        url.searchParams.set('sort_by','created-descending');
        url.searchParams.set('section_id','xp-arrivals-products');
        const response=await fetch(url);
        if(!response.ok)throw Error('Arrivals unavailable');
        const document=new DOMParser().parseFromString(await response.text(),'text/html');
        const template=document.querySelector('template[data-arrivals-products]');
        if(!template)throw Error('Unexpected arrivals response');
        grid.replaceChildren(...[...template.content.children].slice(0,Number(this.dataset.limit)||4));
      } catch(error) {
        grid.replaceChildren();
        const status=this.querySelector('[data-arrivals-status]');
        status.textContent='Explore our newest pieces using “See what’s new” above.';status.hidden=false;
      } finally { grid.removeAttribute('aria-busy'); }
    }
  });
})();
